import { render, staticRenderFns } from "./Truncate.vue?vue&type=template&id=45a8cce3&"
import script from "./Truncate.vue?vue&type=script&lang=js&"
export * from "./Truncate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports